import {BaseContainerModel} from '../base-container.model';
import {
  bl_fi_generic_doc_budget_sub_line_RowClass,
  bl_fi_generic_doc_event_RowClass,
  bl_fi_generic_doc_ext_RowClass,
  bl_fi_generic_doc_hdr_RowClass,
  bl_fi_generic_doc_hdr_RowInterface,
  bl_fi_generic_doc_line_RowClass,
  bl_fi_generic_doc_link_RowClass
} from '../../dbschema/index';

export class GenericDocContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_hdr: bl_fi_generic_doc_hdr_RowInterface = new bl_fi_generic_doc_hdr_RowClass();
  bl_fi_generic_doc_event: bl_fi_generic_doc_event_RowClass[] = [];
  bl_fi_generic_doc_ext: bl_fi_generic_doc_ext_RowClass[] = [];
  bl_fi_generic_doc_link: bl_fi_generic_doc_link_RowClass[] = [];
  bl_fi_generic_doc_line: bl_fi_generic_doc_line_RowClass[] = [];
  bl_fi_generic_doc_budget_sub_line?: bl_fi_generic_doc_budget_sub_line_RowClass[] = [];
}
